"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultDsn = '//e7152b1b832e4dfe847a66fc9acf006a@sentry-front.cian.ru/9';
exports.ignoreUrls = [
    /kaspersky-labs\.com/i,
];
exports.ignoreErrors = [
    // Временные игноры, блокируем спамящие ошибки, чтобы сентри не падала
    // Игноры относятся к компоненту serp
    // TODO: https://cianru.atlassian.net/browse/CD-7828
    /Не удалось получить свойство \"setter\"/i,
    // TODO: https://cianru.atlassian.net/browse/CD-8014
    /Не удается выполнить программу из освобожденного сценария/i,
    // TODO: https://cianru.atlassian.net/browse/CD-8015
    /^No default value/i,
];
//# sourceMappingURL=config.js.map


//////////////////
// WEBPACK FOOTER
// ./lib/config.js
// module id = 9
// module chunks = 0